<template>
    <div>    
        <section class="welcome-one">
			<div class="container">
                <!-- 工业互联网 -->
                <div class="row" >
                    <div class="col-xl-4 col-lg-12 wow fadeInUp row__item" v-for="(item,index) in solutionList" :key="index"  :data-wow-delay="(index+1)+'ms'" @click="handleDetail(item)">
                        <div style="position: relative; display: block;margin: 10px 15px;">
                            <img  :src="item.imgUrl"  width="370px" height="300px" style="background: #1748a4;"/>
                            <h4 class="row__item_text_title">
                                {{ item.title }}
                                <p class="row__item_text_conter">
                                    {{ item.text }}
                                </p>
                            </h4>
                    </div>
                    </div>
                </div>
			</div>
		</section>
        <seek-dialog v-if="seekShow" :title="title"  @close="handleClose"/>
    </div>
</template>

<script >
import SeekDialog from "@/components/seekDialog"

export default {
    name: 'login',
    components: {
        SeekDialog
    },
    data () {
        return {
            routeList: [],  // 面包屑
            solutionList: [],
            seekShow: false,
            title: "",
        }
    },
    created() {
        this.getList()  // 获取内容
    },
    mounted () {
     
        
    },

    methods: {
       
        // 获取内容
        getList() {
            this.solutionList = JSON.parse(JSON.stringify(window._address_env_.loginList))  
        },
      
        // 打开系统页面
        handleDetail(item) {
            if(item.url) {
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = item.url
                link.target="_blank"    // 在新的tab页打开
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)   // 删除a接点
                window.URL.revokeObjectURL(item.url)   // 销毁
            } else {
                this.title = item.title
                this.seekShow = true
            }
           
        },
         // 关闭弹窗
         handleClose() {
            this.seekShow = false
        }
    }
}
</script>
<style scoped>

   
.welcome-one {
    background: var(--notech-extra);
   padding: 200px 0 110px; 
}

.row__item {
    cursor: pointer;
    position: relative;
    /* background-color:#fff; */
    visibility: visible;
    animation-name: fadeInUp;

}
.col-xl-4 {
    padding: 0;
   
}
.row__item img {
    max-width: 100%;
}
.row__item h4 {
    font-size: var(--font-size-24);
    font-weight: bold;
    position: absolute;
    bottom: 0;
    width: 100%;
    height: 40px;
    line-height: 40px;
    padding-left: 20px;
    box-sizing: border-box;
    left: 0;
    line-height: 30px;
    background: linear-gradient(rgba(0,0,0,0),rgba(0,0,0,0.8));
    color: #FFFFFF;
    transition: all 0.6s;
}

.row__item:hover h4 {
    height: 100%;
    background: rgba(0,0,0,0.5);
    transition: all 0.6s;
    padding-top: 20px;
}
.row__item h4 p {
    font-size: var(--font-size-16);
    font-weight: 100;
    display: none;
    transition: all 0.4s;
    padding-right: 20px;
    line-height: 20px;
}
.row__item:hover h4 p{
    display: block;
    transition: all 6s;
    height: calc(100% - 40px);
    overflow: hidden;  
}
.container_row_title h4{
    font-size: var(--font-size-55);
    text-align: center;
    margin-bottom: 60px;
    line-height: 1.65;
    /* font-size: var(--font-size-55); */
    color: var(--notech-black);
}

.row__item_text {
    position: absolute;
    width: 100%;
    top: 0px;
    left: 0;
    padding: 50px 30px;
    color: #FFFFFF;
    line-height: 2;
}
.row__item_text_title {
    font-size: var(--font-size-24);
    color: var(--notech-white);
}
.row__item_text_icon {
    font-size: var(--font-size-66);
   
}
.row__item_text_conter {
    font-size: var(--font-size-16);
}
.icon_left{
    float: left;
    margin: 0 15px;
    margin-bottom: 50px;
}
.icon_right{
    float: right;
    margin: 0 15px;
    margin-bottom: 50px;
}
</style> 
